
$(document).ready(() ->
    onMouseEnter = () ->
        ttAnchor = $(this).find('.tt-anchor')
        ttInner = $(this).find('.tt-inner')

        # Position anchor in the middle of the element.
        ttAnchor.offset({
            top: $(this).offset().top + 0.5 * $(this).height() - 0.5 * ttAnchor.height()
            left: $(this).offset().left + 0.5 * $(this).width() - 0.5 * ttAnchor.width()
        })
        # Show actual tooltip.
        ttInner.css('display', 'block')

        # Actually move tooltip to within the screen if necessary.
        # Has to be done after making it visible to get the right offset.
        leftPos = ttInner.offset().left
        if leftPos < 5
            ttAnchor.offset({
                top: ttAnchor.offset().top
                left: ttAnchor.offset().left - leftPos + 5
            })
        if leftPos + ttInner.width() > $(window).width() - 5
            ttAnchor.offset({
                top: ttAnchor.offset().top
                left: ttAnchor.offset().left - leftPos - ttInner.width() + $(window).width() - 5
            })

    onMouseLeave = () ->
        $(this).find('.tt-inner').css('display', 'none')

    $(document).on('mouseenter', '.abbr, .tt, .tt-small, .tt-color', onMouseEnter)
    $(document).on('mouseleave', '.abbr, .tt, .tt-small, .tt-color', onMouseLeave)
)
